<div class="full-height" *ngIf="!showTask">
    <div class="alert alert-warning" role="alert" *ngIf="connectionWarningMessage">
        <img src="assets/img/icons/InfoOutlined.svg" />
        <div>
            <p *ngIf="!isMobile" class="m-0" >{{'ERROR_MESSAGES.MISSING_CONNECTION.LAPTOP' | translate}}
                (<a href="https://play.google.com/store/apps/details?id=com.paulhartmann.bodeHygienePlatform" target="blank" >Android</a>
                {{'ERROR_MESSAGES.MISSING_CONNECTION.AND' | translate}}
                <a href="https://apps.apple.com/de/app/my-hygiene-sop/id1464124118" target="_blank" >Apple</a>)
            </p>
            <p *ngIf="isMobile && isApple" class="m-0">{{'ERROR_MESSAGES.MISSING_CONNECTION.APPLE' | translate}}
                <a href="https://apps.apple.com/de/app/my-hygiene-sop/id1464124118" target="_blank" >Apple</a>
            </p>
            <p *ngIf="isMobile && !isApple" class="m-0" >{{'ERROR_MESSAGES.MISSING_CONNECTION.ANDROID' | translate}}
                <a href="https://play.google.com/store/apps/details?id=com.paulhartmann.bodeHygienePlatform" target="blank" >Android</a>
            </p>
            <div class="d-flex justify-content-between pt-3">
                <a href="https://apps.apple.com/de/app/my-hygiene-sop/id1464124118" target="_blank" *ngIf="showMessageApple"><img src="assets/icons/download-apple.png" /></a>
                <a href="https://play.google.com/store/apps/details?id=com.paulhartmann.bodeHygienePlatform" target="blank" *ngIf="showMessageAndroid"><img src="assets/icons/download-android.png"/></a>
            </div>
        </div>
    </div>
    <h3 class="section-title mt-4 mb-3">{{ 'SOP_OBSERVATION.SELECT.FIELD_OF_ACTIVITY' | translate }}</h3>
    <form [formGroup]="formdata" (ngSubmit)="onClickSubmit(formdata.value)" #ngForm="ngForm">
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <div class="dropdown dropdown-bhp" style="width: 240px; min-width: 345px;" id="ward-dropdown">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input formControlName="ward" hidden />
                            <input class="dropdown-toggle" type="text" formControlName="wardName" readonly (click)="onClickWardHandler($event)"
                            [ngClass]="{'is-invalid':formdata.get('ward').errors && (formdata.get('ward').touched || formdata.get('ward').dirty || ngForm.submitted)}" />
                            <span class="label-dropdown">{{ translationKeys.Configure.Ward | translate }}*</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />                            
                        </div>
                        <ul class="dropdown-menu">
                            <li [ngValue]="ward" class="dropdown-item" *ngFor="let ward of allWards; let i = index" 
                                (click)="onWardIDChange(ward)"
                                [ngClass]=" formdata.get('wardName').value === ward.wardName ? 'active' : ''">  
                                {{ ward.wardName | labelSanitizer }} 
                            </li>
                        </ul>
                    </div>

                    <div class="invalid-feedback" *ngIf="formdata.get('ward').errors && (formdata.get('ward').touched || formdata.get('ward').dirty || ngForm.submitted)">
                        <span *ngIf="formdata.get('ward').errors.required">
                            {{ translationKeys.ErrorMessages.RequiredWard | translate }}
                        </span>
                    </div> 
                </div>
            </div>
            <div class="col-sm-12" *ngIf="allWards.length > 0">
                <div class="form-group">
                    <label>{{ translationKeys.Configure.Department | translate }}</label>
                    <p>{{formdata.get('department').value.departmentName | translate | labelSanitizer}} {{ getDepartmentTypeName(formdata.get('ward').value) }}</p>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <div class="dropdown dropdown-bhp" style="width: 240px; min-width: 345px;" id="category-dropdown">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input formControlName="category" hidden />
                            <input class="dropdown-toggle" type="text"  [value]="formdata.get('categoryName').value | translate " readonly
                            [ngClass]="{'is-invalid':formdata.get('category').errors && (formdata.get('category').touched || formdata.get('category').dirty)}" />
                            <span class="label-dropdown">{{ 'CONFIGURE.PROFESSIONAL_CATEGORY' | translate }}*</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                        </div>
                        <ul class="dropdown-menu">
                            <li [ngValue]="professionalCategory" class="dropdown-item" *ngFor="let professionalCategory of allProfessionalCategories" 
                                (click)="onProfessionalCategoryChange(professionalCategory)"
                                [ngClass]=" formdata.get('categoryName').value === professionalCategory.categoryName ? 'active' : ''">  
                                {{ professionalCategory.categoryName | translate | labelSanitizer }} 
                            </li>
                        </ul>
                    </div>

                    <div class="invalid-feedback" *ngIf="formdata.get('category').errors && (formdata.get('category').touched || formdata.get('category').dirty)">
                        <span *ngIf="formdata.get('category').errors.required">
                            {{ translationKeys.ErrorMessages.RequiredProfessionalCategory | translate }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-sm-12" *ngIf="showProfessionalSubcategory">
                <div class="form-group mb-0">
                    <div class="dropdown dropdown-bhp" style="width: 240px; min-width: 345px;" id="subcategory-dropdown">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input formControlName="subCategory" hidden />
                            <input class="dropdown-toggle" type="text" [value]="layoutService.getSubCategoryName(formdata.get('subCategory').value) | translate " readonly/>
                            <span class="label-dropdown">{{ 'CONFIGURE.PROFESSIONAL_SUB_CATEGORY' | translate }}</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                        </div>
                        <ul class="dropdown-menu">
                            <li [ngValue]="subCategory" class="dropdown-item" *ngFor="let subCategory of allSubCategoriesSelected" 
                                (click)="onProfessionalSubCategoryChange(subCategory)"
                                [ngClass]=" formdata.get('subCategoryName').value === layoutService.getSubCategoryName(subCategory) ? 'active' : ''">  
                                {{layoutService.getSubCategoryName(subCategory) | translate | labelSanitizer}}
                            </li>
                        </ul>
                    </div>

                    <div class="invalid-feedback" *ngIf="showFieldInvalid('subCategory')">
                        <span *ngIf="formdata.get('subCategory').errors.required">
                                {{ 'ERROR_MESSAGES.REQUIRED.PROFESSIONAL_SUB_CATEGORY' | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="alert alert-warning mt-2" role="alert" *ngIf="wardWarningMessage && (userRoleId == 5)">
            {{ 'CONFIGURE.NOT_CONFIGURED_CONTACT_INSTITUTION_ADMIN.WARD' | translate }}
        </div>
        <div class="alert alert-warning mt-2" role="alert" *ngIf="wardWarningMessage && (userRoleId == 4)">
            {{ 'CONFIGURE.NOT_CONFIGURED_REFERENCE_CONFIGURATION.WARD' | translate }}
        </div>
        
        <div class="bd " *ngIf="!wardWarningMessage && (userRoleId == 4 || userRoleId == 5)">
            <div class="my-2">
                <button type="submit" class="btn-bd-empty" id="start-observation-button">{{ 'SOP_OBSERVATION.NEXT_STEP' | translate }}</button>
            </div>
        </div>
    </form>
</div>
<div *ngIf="showTask">
    <lib-ph-bhp-select-sopobserve [userData]='appConfig.userData' [formdata]="formdata.value" (childData)="selectSopobserveChildData($event)" [isDesktop]='true'>
    </lib-ph-bhp-select-sopobserve>
</div>